var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-circle",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x1: 4,
    y2: 4,
    transform: "translate(5 5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x2: 4,
    y2: 4,
    transform: "translate(5 5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.e4272d212e27d3e0d73e664d443b3c13.svg";
export { ForwardRef as ReactComponent };